<template>
    <component
        :is="element"
        :to="to"
        @click="$emit('click')"
        class="button"
        :class="{'is-loading': loading}">

        <span v-if="icon" class="icon"><i :class="icon"></i></span>
        <span v-if="$slots.default"><slot></slot></span>
        <span v-else-if="text">{{text}}</span>
    </component>
</template>

<script>
export default {
    name: 'Button',
    props: {
        icon: String,
        loading: Boolean,
        to: { default: '' },
        text: String,
    },
    computed: {
        element() {
            return this.to !== '' ? 'router-link' : 'a';
        },
    },
};
</script>

<style scoped>
    .button {margin-bottom: 10px;}
</style>
